import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { HelpCircle } from "lucide-react";
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "@/components/ui/tooltip";

// Map the current app route to the most relevant Help & Guide section id.
const ROUTE_TO_SECTION = {
  "/app/log": "logging",
  "/app/reports": "reports",
  "/app/context": "context",
  "/app/history": "history",
  "/app/dashboard": "history",
  "/app/access": "privacy",
  "/app/team": "team",
  "/app/organization": "org",
  "/app/billing": "billing",
  "/app/settings": "faq",
};

export default function HelpLauncher() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Don't show the launcher on the Help page itself.
  if (location.pathname.startsWith("/app/help")) return null;

  const section = ROUTE_TO_SECTION[location.pathname] || "welcome";

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            onClick={() => navigate(`/app/help?to=${section}`)}
            data-testid="help-launcher"
            aria-label={t("notif.openHelp")}
            className="fixed top-5 right-6 z-40 h-10 w-10 rounded-full bg-[#ECECEC] text-[#202123] border border-[#C5C5D0] shadow-lg shadow-black/5 flex items-center justify-center hover:bg-[#E0E0E0] transition-colors">
            <HelpCircle className="h-5 w-5" />
          </button>
        </TooltipTrigger>
        <TooltipContent side="left" className="bg-navy text-white border-navy">{t("notif.helpForPage")}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
